import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import modelClassRequire from "@kaspernj/api-maker/build/model-class-require.js"

const modelClassData = {
  "attributes": {
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": true
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": true
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": true
    },
    "name": {
      "column": null,
      "name": "name",
      "selected_by_default": false,
      "translated": true
    },
    "name_da": {
      "column": null,
      "name": "name_da",
      "selected_by_default": false,
      "translated": false
    },
    "name_en": {
      "column": null,
      "name": "name_en",
      "selected_by_default": false,
      "translated": false
    },
    "name_no": {
      "column": null,
      "name": "name_no",
      "selected_by_default": false,
      "translated": false
    },
    "name_se": {
      "column": null,
      "name": "name_se",
      "selected_by_default": false,
      "translated": false
    }
  },
  "className": "SchoolClassGroup",
  "collectionKey": "school_class_groups",
  "collectionName": "school_class_groups",
  "i18nKey": "school_class_group",
  "camelizedLower": "schoolClassGroup",
  "name": "SchoolClassGroup",
  "nameDasherized": "school-class-group",
  "pluralName": "school_class_groups",
  "ransackable_associations": [
    {
      "className": "SchoolClassGroup::Audit",
      "collectionName": "school_class_group_audits",
      "foreignKey": "school_class_group_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "SchoolClassGroupAudit",
      "through": null
    },
    {
      "className": "ClassStatusExpansion",
      "collectionName": "class_status_expansions",
      "foreignKey": "resource_id",
      "name": "class_status_expansion",
      "macro": "has_many",
      "resource_name": "ClassStatusExpansion",
      "through": null
    },
    {
      "className": "ClassStep",
      "collectionName": "class_steps",
      "foreignKey": "class_step_id",
      "name": "class_steps",
      "macro": "has_many",
      "resource_name": "ClassStep",
      "through": "school_class_group_class_steps"
    },
    {
      "className": "SchoolClassGroup::Audit",
      "collectionName": "school_class_group_audits",
      "foreignKey": "school_class_group_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "SchoolClassGroupAudit",
      "through": null
    },
    {
      "className": "SchoolClassGroup::Translation",
      "collectionName": null,
      "foreignKey": "school_class_group_id",
      "name": "current_translation",
      "macro": "has_one",
      "resource_name": null,
      "through": null
    },
    {
      "className": "SchoolClassGroupClassStep",
      "collectionName": "school_class_group_class_steps",
      "foreignKey": "school_class_group_id",
      "name": "school_class_group_class_steps",
      "macro": "has_many",
      "resource_name": "SchoolClassGroupClassStep",
      "through": null
    },
    {
      "className": "SchoolClassGroup::Translation",
      "collectionName": null,
      "foreignKey": "school_class_group_id",
      "name": "translations",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [
    {
      "className": "ClassStep",
      "collectionName": "class_steps",
      "foreignKey": "class_step_id",
      "name": "class_steps",
      "macro": "has_many",
      "resource_name": "ClassStep",
      "through": "school_class_group_class_steps"
    }
  ],
  "paramKey": "school_class_group",
  "primaryKey": "id"
}

/** Frontend model for SchoolClassGroup. */
class SchoolClassGroup extends BaseModel {
  /** @returns {Record<string, any>} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameDa() {
    return this.readAttributeUnderscore("name_da")
  }

  /** @returns {boolean} */
  hasNameDa() {
    const value = this.nameDa()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameEn() {
    return this.readAttributeUnderscore("name_en")
  }

  /** @returns {boolean} */
  hasNameEn() {
    const value = this.nameEn()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameNo() {
    return this.readAttributeUnderscore("name_no")
  }

  /** @returns {boolean} */
  hasNameNo() {
    const value = this.nameNo()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameSe() {
    return this.readAttributeUnderscore("name_se")
  }

  /** @returns {boolean} */
  hasNameSe() {
    const value = this.nameSe()

    return this._isPresent(value)
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./class-step.js").default>} */
  classSteps() {
    const modelClass = modelClassRequire("ClassStep")

    return new Collection(
      {
        reflectionName: "class_steps",
        model: this,
        modelName: "ClassStep",
        modelClass
      },
      {
        params: {
          through: {
            model: "SchoolClassGroup",
            id: this.primaryKey(),
            reflection: "class_steps"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./class-step.js").default>>} */
  loadClassSteps() {
    const modelClass = modelClassRequire("ClassStep")

    return this._loadHasManyReflection(
      {
        reflectionName: "class_steps",
        model: this,
        modelClass
      },
      {
        params: {
          through: {
            model: "SchoolClassGroup",
            id: this.primaryKey(),
            reflection: "class_steps"
          }
        }
      }
    )
  }
}

export default SchoolClassGroup
